<!--
 * @Description: 自助取证列表
 * @Date: 2019-10-21 09:56:59
 * @LastEditTime: 2021-07-23 14:12:32
 -->
<template>
  <div id="forensicList">
    <!-- S 表格筛选 -->
    <TableSearch
      ref="TableSearch"
      :key="forceUpdateKey"
      v-model="searchForm"
      :options="searchOptions"
      :show-toggle="true"
      @submit="setSearch"
    >
      <div slot="button" class="btn-group">
        <el-upload
          ref="upload"
          action
          :auto-upload="false"
          :http-request="handleUploadFile"
          :show-file-list="false"
          :on-change="handleFileChange"
          :accept="acceptFileType"
        >
          <div class="btn-item">
            <el-button type="primary" icon="el-icon-plus">
              新建
            </el-button>
          </div>
        </el-upload>
        <div class="btn-item">
          <el-button icon="el-icon-upload2" @click="handleBatchUpload">
            批量上传
          </el-button>
        </div>
        <div class="btn-item">
          <el-button :loading="submitLoading" icon="el-icon-delete" @click="handleDeleteSubmit">
            批量删除
          </el-button>
        </div>
      </div>
      <!-- /表格操作 -->
    </TableSearch>
    <!-- E 表格筛选 -->

    <!-- S 表格 -->
    <div class="forensic-table-wrap">
      <el-table
        v-loading="items.loading"
        class="list-table"
        :data="items.data"
        :auto-upload="false"
        tooltip-effect="dark"
        stripe
        @selection-change="val=> multipleSelection = val"
      >
        <el-table-column
          type="selection"
          width="60"
          :selectable="handleSelectable"
          align="center"
        />
        <el-table-column label="泄密样本" width="150" align="center">
          <template slot-scope="scope">
            <el-popover placement="right" trigger="hover" width="284" popper-class="img-names-popover">
              <div class="img-names">
                <div class="name">
                  <p>{{ productName === '文件溯源' ? '文件名称' : '图片名称' }}：</p>
                  <p>{{ scope.row.imageName || '--' }}</p>
                </div>
                <div class="name">
                  <p>源文件名：</p>
                  <p>{{ scope.row.fileOrioriginalName || '--' }}</p>
                </div>
              </div>
              <img
                v-if="checkFileType(scope.row.fileOrioriginalName)==='pdf' || checkFileType(scope.row.fileOrioriginalName)==='ofd'"
                slot="reference"
                src="../../assets/imgs/file.png"
                class="forensicList-img"
                alt=""
              >
              <img
                v-else-if="checkFileType(scope.row.fileOrioriginalName)==='video'"
                slot="reference"
                class="forensicList-img"
                src="../../assets/imgs/u994.svg"
                alt=""
              >
              <img
                v-else
                slot="reference"
                v-lazy="scope.row.thumbnailPath"
                style="cursor: pointer;"
                class="forensicList-img"
                @click="handlePreviewImg(scope.row)"
              >
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="上传时间"
          align="center"
          show-overflow-tooltip
        />

        <el-table-column
          prop="username"
          label="取证用户"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="watermarkType"
          label="水印类型"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.watermarkType | filterWatermark }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="appName" align="center" min-width="115px" show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-popover
              v-model="showHeaderPopover"
              placement="bottom"
              trigger="click"
              @show="handleGetApps"
            >
              <div
                slot="reference"
                :data="scope.row"
                class="custom-header"
                :class="{'custom-header-active': showHeaderPopover || appIds.length}"
              >
                <span>所属应用</span>
                <i class="iconfont icon-select" />
              </div>
              <div class="custom-header-content">
                <el-checkbox-group v-model="appIds" class="check-group">
                  <el-checkbox
                    v-for="(item,index) in appOptions"
                    :key="index"
                    :label="item.aid"
                    class="check-item"
                  >
                    {{ item.appName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="custom-header-footer">
                <button @click="handleSubmitApp">
                  确认
                </button>
                <button @click="handleResetApp">
                  重置
                </button>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.appName || '— —' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="forensicResult"
          label="取证状态"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.forensicResult === '---' || scope.row.forensicResult === '失败'">— —</span>
            <span v-else-if="scope.row.forensicResult === '取证中'" :class="scope.row.forensicResult | statusFilter">自动取证中</span>
            <span v-else :class="scope.row.forensicResult | statusFilter">{{ scope.row.forensicResult }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="scope">
            <div class="table-operate-wrap">
              <el-button
                v-if="scope.row.forensicResult === '待取证'"
                type="primary"
                @click="handleForensic(scope.row)"
              >
                取证
              </el-button>
              <el-button
                v-if="scope.row.forensicResult === '---' || scope.row.forensicResult === '已撤销' || scope.row.forensicResult === '取证中'"
                type="primary"
                :disabled="productName ==='文件溯源' || scope.row.forensicResult === '待取证' || scope.row.forensicResult === '取证中'"
                @click="handleForensic(scope.row)"
              >
                重新取证
              </el-button>
              <el-button
                v-if="scope.row.forensicResult === '成功'&&scope.row.unicomFlag"
                type="primary"
                @click="handleReport(scope.row)"
              >
                查看报告
              </el-button>
              <el-button size="small" @click="handleDetail(scope.row)">
                详情
              </el-button>
              <el-button
                v-if="((scope.row.forensicResult === '---' || scope.row.forensicResult === '已撤销' || scope.row.forensicResult === '取证中') && scope.row.watermarkType) && productName !== '文档中心打印溯源'"
                type="danger"
                :disabled="productName === '文件溯源' || scope.row.forensicResult === '取证中'"
                @click="handleDeepForensic(scope.row)"
              >
                深度取证
              </el-button>
              <el-popover
                v-model="scope.row.showPopover"
                popper-class="table-operate-popper"
                placement="bottom"
                width="80"
                trigger="hover"
              >
                <ul class="operate-popper-list">
                  <li v-if="productName !== '电子文档水印溯源'" @click="handleExport(scope.row)">
                    导出文件
                  </li>
                  <li @click="handleForensic(scope.row)">
                    重新取证
                  </li>
                  <li @click="handleDeepForensic(scope.row)">
                    深度取证
                  </li>
                </ul>
                <el-button
                  v-show="scope.row.forensicResult === '成功' && productName !== '文档中心打印溯源'"
                  slot="reference"
                  :disabled="productName === '文件溯源'"
                  :type="scope.row.showPopover ? 'primary' : 'default'"
                  style="margin-left: 10px;"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="items.total"
        class="pagination-wrap"
        background
        :current-page="items.pageNum"
        :page-size="items.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="items.total"
        @size-change="setPageSize"
        @current-change="setPageNum"
      />
      <!-- /分页 -->
    </div>
    <!-- E 表格 -->

    <!-- S 图片上传 -->
    <el-dialog
      title="新建取证"
      class="forensic-upload-wrap"
      :visible.sync="uploadForm.visible"
      :close-on-click-modal="false"
      center
      width="380px"
    >
      <div class="content">
        <img v-lazy="uploadForm.imageUrl" alt>
        <span>是否新建取证？</span>
      </div>

      <span class="footer">
        <el-button @click="uploadForm.visible = false">取 消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="handleSubmitUpload">{{ submitBtnText }}</el-button>
      </span>
    </el-dialog>
    <!-- E 图片上传 -->

    <!-- S 取证结果 -->
    <el-dialog
      :visible.sync="successDialog"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="forensic-result-wrap"
      width="550px"
      top="0vh"
    >
      <div class="result-header">
        <img src="~assets/imgs/bg-suc.png" alt="">
      </div>
      <div class="result-content">
        <dl class="is-success lg-label-width">
          <dt>
            <span>溯源标识：</span>
            <span>{{ fileResult.shfCodeEncryption || '--' }}</span>
          </dt>
          <dt class="distance">
            <span>水印嵌入时间：</span>
            <span>{{ fileResult.watermarkTime }}</span>
          </dt>
          <dd>
            <span>姓名：</span>
            <span>{{ fileResult.userName || '--' }}</span>
          </dd>
          <dd>
            <span>工号：</span>
            <span>{{ fileResult.userNo || '--' }}</span>
          </dd>
          <dd>
            <span>IP地址：</span>
            <span>{{ fileResult.ip || '--' }}</span>
          </dd>
          <dd>
            <span>MAC地址：</span>
            <span>{{ fileResult.mac || '--' }}</span>
          </dd>
          <dd>
            <span>硬件编号：</span>
            <span>{{ fileResult.hardwareInfo || '--' }}</span>
          </dd>
        </dl>
      </div>
      <div class="result-footer">
        <el-button @click="successDialog = false">
          关闭
        </el-button>
        <el-button type="primary" @click="handleReport(fileResult)">
          查看报告
        </el-button>
      </div>
    </el-dialog>
    <!-- / 取证成功-t2互通 -->

    <!-- E 非互通-取证成功 -->
    <el-dialog
      :visible.sync="errorDialog"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="forensic-result-wrap"
      width="550px"
      top="0vh"
    >
      <div class="result-header">
        <img src="~assets/imgs/bg-fail.png" alt="">
      </div>
      <div class="result-content">
        <dl class="is-fail">
          <dt>原因可能是：</dt>
          <dd>1.您的文件可能在拍摄、传输或存储过程中受到干扰。</dd>
        </dl>
      </div>
      <div class="result-footer">
        <el-button @click="errorDialog = false">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- E 取证失败 -->

    <!-- S 详情 -->
    <ForensicDetail :id="showDetail.id" v-model="showDetail.visible" />
    <!-- E 详情 -->

    <!-- S 图片预览 -->
    <PreviewImg ref="preview" />
    <!-- E 图片预览 -->

    <!-- S 批量上传水印类型选择 -->
    <WatermarkSelect v-model="showWatermarkSelect" @handleSubmit="val => showBatchUpload = val" />
    <!-- E 批量上传水印类型选择 -->

    <!-- S 图片批量上传 -->
    <BatchUpload ref="BatchUpload" v-model="showBatchUpload" />
    <!-- E 图片批量上传 -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { TableSearch, ForensicDetail, PreviewImg } from '@/components'
import BatchUpload from './components/BatchUpload'
import WatermarkSelect from './components/WatermarkSelect'
import * as tool from '@/utils/tools'
import { searchOptions, checkFileType, VIDEO_TYPES, IMG_TYPES, ACCEPT_FILE_TYPE } from './Config';

export default {
  components: {
    TableSearch,
    ForensicDetail,
    PreviewImg,
    BatchUpload,
    WatermarkSelect
  },
  filters: {
    statusFilter(val) {
      if (val === '待取证' || val === '取证中' || val === '待受理' || val === '取证中') {
        return 'status-active'
      }
    },
    filterWatermark(type) {
      switch (type) {
        case 1:
          return 'PC屏幕水印'
        case 2:
          return '手机屏幕水印'
        case 3:
          return '网页水印'
        case 4:
          return '手机原生图片水印'
        case 5:
          return '电子文档水印'
        case 6:
          return '图片水印'
        case 7:
          return '视频水印'
        case 8:
          return '终端打印水印'
        default:
          return '— —'
      }
    }
  },
  data() {
    return {
      file: '',
      searchForm: {},
      searchOptions,
      acceptFileType: ACCEPT_FILE_TYPE,
      multipleSelection: [], // 表格多选
      showHeaderPopover: false,
      appOptions: [], // 应用列表
      appIds: [], // 选择的应用ID
      uploadForm: {
        imageSize: 0,
        imageUrl: '',
        visible: false
      },
      showDetail: {
        id: '',
        visible: false
      },
      showWatermarkSelect: false,
      showBatchUpload: false,
      uploadFileType: '', // 上传的文件类型
      submitBtnText: '确定',
      successDialog: false,
      errorDialog: false,
      fileResult: '', // 取证结果
      checkFileType,
      productType: [],
      forceUpdateKey: 0
    };
  },
  computed: {
    ...mapState({
      items: state => state.forensic.items,
      detail: state => state.forensic.detail.data,
      productName: state => state.product.item.productName,
      submitLoading: state => state.forensic.submitLoading,
      uploadLoading: state => state.forensic.uploadLoading,
      screenTimeLabel: state => state.product.screenTimeLabel,
      watermarkTypes: state => state.forensic.watermarkTypes,
      products: state => state.product.items,
      productId: state => state.product.item.productId,
      batchUploading: state => state.forensic.batchUploading
    })
  },
  watch: {
    productName(val) {
      this.appIds = []
      this.clearFilter()
      this.getList();
    },
    'uploadForm.visible'(val) {
      if (!val) {
        this.$refs.upload.clearFiles()
      }
    },
    showBatchUpload(val) {
      console.log(this.batchUploading)
      if (!val) {
        this.getList()
      }
    },
    appIds(val) {
      this.$store.commit('forensic/setFilter', { aId: val })
    }
  },
  mounted() {
    if (!this.isMainAccount && this.searchOptions.length == 3) this.searchOptions.splice(1, 1)
    this.productTypeQuery()
  },
  methods: {
    ...mapActions({
      getList: 'forensic/getList',
      getProductList: 'product/getList',
      getDetail: 'forensic/getDetail',
      getAppList: 'product/getAppList',
      setSearch: 'forensic/setSearch',
      setPageNum: 'forensic/setPageNum',
      setPageSize: 'forensic/setPageSize',
      setSort: 'forensic/setSort',
      setFilter: 'forensic/setFilter',
      clearFilter: 'forensic/clearFilter',
      remove: 'forensic/remove',
      upload: 'forensic/upload',
      getDeepList: 'deepForensic/getList',
      exportZip: 'forensic/exportZip',
      checkNumber: 'deepForensic/checkNumber',
      setForensicItem: 'forensic/setForensicItem'
    }),
    // 批量上传文件
    handleBatchUpload() {
      if (this.watermarkTypes.length === 1) {
        const { id } = this.watermarkTypes[0]
        this.$store.commit('forensic/setBatchUploadWatermarkType', id)
        this.showBatchUpload = true
      } else {
        this.showWatermarkSelect = true
      }
    },
    // 查看详情
    handleDetail(row) {
      this.showDetail.visible = true
      this.showDetail.id = row.id
    },
    // 切换产品
    productTypeQuery() {
      this.getProductList().then(() => {
        this.products.data.forEach((el) => {
          this.productType.push({
            label: el.productName,
            value: el.productId
          })
        });
        this.searchOptions[0].options = this.productType;
        this.setSearch({ productId: this.productId })
        this.searchForm = this.items.search
      })
    },
    /**
     * 文件上传
     * 1、判断是否为视频上传
     * 2、视频上传不需要进行图片纠正操作、转base64操作
     */
    handleUploadFile() {
      this.upload({ file: this.file.raw }).then(res => {
        this.setUploadData(res)
      })
    },
    /**
     * 文件上传成功处理
     * 1、判断当前上传的文件是否已存在
     * 2、存在->根据取证记录详情判断当前取证记录的状态
     * 3、存在->判断是否是深度取证 前往查看结果
     */
    setUploadData(res) {
      this.$store.commit('forensic/setForensicAgain', 0);
      if (!res.exists) {
        this.setForensicItem(res).then(() => {
          this.linkTo('/forensic/component')
        })
      } else {
        // 查询这张已存在的图片状态
        let message = '存在'
        this.$store.commit('forensic/setUploadLoading', true)
        this.getDetail({ id: res.id }).then((r) => {
          const detail = r.data.data
          this.uploadForm.visible = false
          if (res.forensicType === 2) {
            message = '申请深度取证'
          } else if (detail.forensicResult === '成功') {
            message = '取证成功'
          }
          // 定时器是处理闪屏的问题
          setTimeout(() => {
            this.$confirm(`该文件已${message}，是否前往查看结果？`, '提示', {
              confirmButtonText: '查看',
              cancelButtonText: '取消',
              center: true
            }).then(() => {
              this.$store.commit('product/setProduct', {
                productName: '全部',
                productId: ''
              })
              if (res.forensicType === 1) {
                this.clearFilter()
                this.$store.commit('forensic/setPageNum', 1)
                this.$store.commit('forensic/setExistRecordId', res.id)
                this.forceUpdateKey = this.forceUpdateKey + 1
                this.setSearch({
                  productId: '',
                  forensicId: res.id
                })
              } else {
                this.$router.push(`/deepForensic/list?forensicId=${res.id}`)
              }
            })
          }, 300);
        }).finally(() => {
          this.$store.commit('forensic/setUploadLoading', false)
        })
      }
    },
    // 提交图片上传
    handleSubmitUpload() {
      // 为了避免大文件上传过程中（转base64）耗时点击多次会发多次请求
      this.$store.commit('forensic/setUploadLoading', true)
      if (this.uploadForm.imageUrl) {
        if (this.productName === '文件溯源') {
          this.submitBtnText = '取证中'
        }
        this.$refs.upload.submit();
      }
    },
    /**
     * @desc 文件选择
     * @param file {file} 文件内容
     * @return: void
     */
    handleFileChange(file, fileList) {
      this.file = file;
      const type = file.raw.type
        ? file.raw.type.split('/')[1].toLocaleLowerCase()
        : null;
      const limit100M = file.size / 1024 / 1024 < 100;
      if (!limit100M) {
        this.$message.error('取证文件不能超过100MB');
        throw new Error('取证文件不能超过100MB')
      } else if (type === 'pdf' || type === 'ofd') {
        this.$store.commit('forensic/setForensicFileType', 'pdf');
        this.uploadForm.imageUrl = require('../../assets/imgs/file.png');
        this.uploadForm.visible = true
        this.file = file;
      } else if (VIDEO_TYPES.includes(file.name.split('.')[1])) {
        this.$store.commit('forensic/setForensicFileType', 'video');
        this.uploadForm.imageUrl = require('../../assets/imgs/u994.svg');
        this.uploadForm.visible = true
        this.file = file
      } else if (IMG_TYPES.toString().indexOf(type) > -1) {
        this.$store.commit('forensic/setForensicFileType', 'img');
        const img = new Image();
        img.src = URL.createObjectURL(file.raw);
        img.onload = () => {
          if (img.width < 200 || img.height < 200) {
            return this.$message.error('暂不支持取证200*200像素以下的图片');
          } else {
            this.uploadForm.imageUrl = window.URL.createObjectURL(file.raw);
            this.uploadForm.visible = true
            this.file = file
          }
        };
        img.onerror = (e) => {
          this.$message.error('上传失败，您的取证文件被损坏');
          throw new Error('上传失败，您的取证文件被损坏')
        }
      } else {
        this.$message.error('文件格式不正确');
        throw new Error('文件格式不正确')
      }
    },
    // 图片预览
    handlePreviewImg(row) {
      this.$refs.preview.visible = true
      this.$refs.preview.src = row.sourceImagePath
    },
    // 提交选择的应用
    handleSubmitApp() {
      this.showHeaderPopover = false;
      this.getList();
    },
    handleResetApp() {
      this.appIds = [];
      this.showHeaderPopover = false;
      this.clearFilter()
      this.getList();
    },
    // 取证
    handleForensic(row) {
      this.$store.commit('forensic/setForensicFileType', checkFileType(row.fileOrioriginalName));
      this.$store.commit('forensic/setForensicAgain', 1);
      this.setForensicItem(row).then(() => {
        this.linkTo('/forensic/component')
      })
    },
    // 批量删除
    handleDeleteSubmit() {
      if (this.multipleSelection.length === 0) {
        this.$message.error({
          message: '请选择要删除的记录',
          duration: 3000,
          center: true
        });
      } else {
        this.$alert('删除之后不可恢复，确定删除？', '删除', {
          showCancelButton: true,
          center: true
        }).then(action => {
          if (action === 'confirm') {
            const ids = this.multipleSelection.map(item => {
              return item.id;
            });
            this.remove({
              ids: ids
            }).then(res => {
              this.$message({
                type: 'success',
                message: '删除成功',
                center: true
              });
            });
          }
        });
      }
    },
    // 判断表格是否可以选择
    handleSelectable(row) {
      if (row.forensicResult === '待受理' || row.forensicResult === '取证中') {
        return 0;
      } else {
        return 1;
      }
    },
    // 获取产品下的app
    handleGetApps() {
      this.getAppList().then(res => {
        this.appOptions = res;
      })
    },
    // 深度取证
    handleDeepForensic(row) {
      this.checkNumber({ userId: row.userId }).then(res => {
        this.setForensicItem(row).then(() => {
          this.linkTo('/deepForensic/create')
        })
      })
    },
    // 查看报告
    handleReport(row) {
      this.setForensicItem(row).then(() => {
        this.linkTo(`/forensic/component?id=${row.id}`)
      })
    },
    // 文件导出
    handleExport(row) {
      window.location.href = '/api/v1/forensic/front/forensic/' + row.id + '/export';
    }
  }
};
</script>
<style lang="scss">
#forensicList {
  height: 100%;
  background: #fff;
  .forensicList-img {
    width: 35px;
    height: 28px;
    cursor: pointer;
  }
  .btn-group {
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    .el-button {
      width: 100px;
      height: 40px;
      padding: 0;
    }
    .btn-item {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .status-active {
    color: #fb9a32;
  }
}
</style>
